/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/open_mobility': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-23 14.914v-7.086l7.086 7.086H4.75zm5.144-5.686l1.051-1.071a.5.5 0 01.713.7l-1.051 1.07a.493.493 0 01-.356.15.498.498 0 01-.357-.849zM4.75 11.836V4.75h7.086L4.75 11.836zm10.31 5.885l-2.04 2.09a.523.523 0 01-.71 0 .51.51 0 01-.149-.351c0-.14.05-.26.149-.36l2.04-2.08a.515.515 0 01.71 0c.09.09.15.211.15.351 0 .129-.05.259-.15.35zm3.722 2.156l-6.659-6.66s7.697-4.775 9.566-2.906c1.87 1.867-2.907 9.566-2.907 9.566zm8.468 7.373h-7.086l7.086-7.086v7.086zm0-15.414L20.164 4.75h7.086v7.086z"/><circle pid="1" cx="18" cy="14" r="1.768"/>'
  }
})
